import React from "react";
import PropTypes from "prop-types";

export const ActionButtons = ({ onCancel, onSave, isLoading, ctaText }) => (
    <div className="flex justify-end gap-4 xl:mt-2 2xl:mt-3 3xl:mt-4">
        <button
            onClick={onCancel}
            className="xl:px-3 2xl:px-4 3xl:px-5 xl:py-1.5 2xl:py-2 3xl:py-2.5
            xl:text-xs 2xl:text-sm 3xl:text-base font-medium
            border xl:border xl:rounded-md 2xl:border-2 2xl:rounded-lg 3xl:border-2 3xl:rounded-lg
            border-red-600 text-red-600
            hover:bg-gray-50 transition-colors duration-200"
        >
            Cancel
        </button>
        <button
            onClick={onSave}
            disabled={isLoading}
            className="xl:px-4 2xl:px-5 3xl:px-6 xl:py-1.5 2xl:py-2 3xl:py-2.5
            xl:text-xs 2xl:text-sm 3xl:text-base font-medium
            xl:rounded-md 2xl:rounded-lg 3xl:rounded-lg
            bg-red-500 text-white
            hover:bg-red-600 transition-colors duration-200
            disabled:opacity-70 disabled:cursor-not-allowed"
        >
            {isLoading ? (
                <div className="xl:w-4 2xl:w-5 3xl:w-6 xl:h-4 2xl:h-5 3xl:h-6 border-2 border-white border-t-transparent rounded-full animate-spin" />
            ) : (
                ctaText
            )}
        </button>
    </div>
);

ActionButtons.propTypes = {
    onCancel: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
    isLoading: PropTypes.bool,
    ctaText: PropTypes.string.isRequired,
};

ActionButtons.defaultProps = {
    isLoading: false,
};
